export function prependDoNotModifyToTitle (title = '') {
  return `Do not modify the notes in this section to avoid tampering with the Poll Everywhere activity.\nMore info at polleverywhere.com/support\n\n${title}`
}

export function prependDoNotModifyToTitles (titles = []) {
  return titles.map(prependDoNotModifyToTitle)
}
